/**
 * @module tree/template
 */

/**
 * @typedef {Document|DocumentFragment|Element|Text} Target
 * @typedef {HTMLTemplateElement} Template
 */

import element from './element.js'

/**
 * Creates a template element
 * @param {Target} target
 * @param {{}} attributes
 * @param {string} innerHTML
 * @returns {Template}
 */
export default (
  target,
  attributes = {},
  innerHTML
) => {
  return Object.assign(element(target, 'template', attributes), {
    innerHTML
  })
}
